import React from 'react'

const encodeEntities = (value) =>
  value
    .split('')
    .map((char) => `&#${char.charCodeAt(0)};`)
    .join('')

const EmailObfuscate = ({ email, text = email }) => {
  const encodedHref = encodeEntities(`mailto:${email}`)
  const encodedText = encodeEntities(text)
  return (
    <span
      dangerouslySetInnerHTML={{
        __html: `<a href="${encodedHref}">${encodedText}</a>`,
      }}
    />
  )
}

export default EmailObfuscate
